import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('pharaohs_riches', {
  cherry: 'scarab',
  lemon: 'canopic_jar',
  orange: 'ankh',
  bell: 'eye_of_horus',
  star: 'pharaoh_mask_wild',
  seven: 'sarcophagus',
  gem: 'jewelled_collar',
  scatter: 'pyramid_scatter',
  money: 'treasure_hoard',
});

/** Pharaoh's Riches — GENERATED by scaffoldSlot from
 *  content/slots/pharaohs_riches.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const PHARAOHS_RICHES_THEME: Theme = {
  id: 'pharaohs_riches',
  name: 'Pharaoh\'s Riches',
  palette: {
    accent: 0xe0a52e,
    secondary: 0x2e78b0,
    warm: 0xffd98a,
    frameFill: 0x1f1810,
    bgGradientTop: 0x2a1f10,
    bgGradientBottom: 0x0f0a04,
    dimOverlay: 0x05080d,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Scarab', glyph: '🪲', tint: 0x2e78b0, weight: 5, textureAlias: 'pharaohs_riches:cherry',
        winVideoAlias: 'pharaohs_riches:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Canopic Jar', glyph: '⚱️', tint: 0xe8d8b0, weight: 5, textureAlias: 'pharaohs_riches:lemon',
        winVideoAlias: 'pharaohs_riches:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Ankh', glyph: '☥', tint: 0xe0a52e, weight: 4, textureAlias: 'pharaohs_riches:orange',
        winVideoAlias: 'pharaohs_riches:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Eye of Horus', glyph: '𓂀', tint: 0xe0a52e, weight: 3, textureAlias: 'pharaohs_riches:bell',
        winVideoAlias: 'pharaohs_riches:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Pharaoh Mask', glyph: '👑', tint: 0xfff2a8, weight: 2, textureAlias: 'pharaohs_riches:star',
        winVideoAlias: 'pharaohs_riches:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Sarcophagus', glyph: '⚰️', tint: 0xe0a52e, weight: 2, textureAlias: 'pharaohs_riches:seven',
        winVideoAlias: 'pharaohs_riches:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Jewelled Collar', glyph: '📿', tint: 0xe0a52e, weight: 2.5, textureAlias: 'pharaohs_riches:gem',
        winVideoAlias: 'pharaohs_riches:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Pyramid', glyph: '🔺', tint: 0xffd98a, weight: 0.5, textureAlias: 'pharaohs_riches:scatter',
        winVideoAlias: 'pharaohs_riches:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Pharaoh\'s Hoard', glyph: '🪙', tint: 0xe0a52e, weight: 1, textureAlias: 'pharaohs_riches:money',
        winVideoAlias: 'pharaohs_riches:money:win:video', winVideoSpeed: 2, isMoney: true },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x0-a', kind: 'multiplier', label: '✕', tint: 0x1f1810, multiplier: 0, weight: 3 },
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0xe0a52e, multiplier: 1, weight: 4 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xffd98a, multiplier: 2, weight: 4 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0x2e78b0, multiplier: 3, weight: 3 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0xe0a52e, multiplier: 1, weight: 4 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xffd98a, multiplier: 5, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xffd98a, multiplier: 2, weight: 3 },
      { id: 'x0-b', kind: 'multiplier', label: '✕', tint: 0x1f1810, multiplier: 0, weight: 2 },
      { id: 'x3-b', kind: 'multiplier', label: '×3', tint: 0x2e78b0, multiplier: 3, weight: 3 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0xe0a52e, multiplier: 10, weight: 2 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xffd98a, multiplier: 5, weight: 2 },
      { id: 'x15-a', kind: 'multiplier', label: '×15', tint: 0xffd98a, multiplier: 15, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'pharaohs_riches:bg', path: 'environment/pharaohs_riches.png' },
      columnBackground: { alias: 'pharaohs_riches:column_bg', path: 'reel/pharaohs_riches_column_bg.png' },
      border: { alias: 'pharaohs_riches:border', path: 'brand/border_egypt.png' },
    },
  },
};
